import React, { useState, useEffect } from "react";
import axios from "../../lib/axios-instance";

const UserList = (props) => {
  const [users, setUsers] = useState(JSON.parse(props.users));

  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (successMessage !== "")
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
  }, [successMessage]);

  const handleAdminChange = (user, checked) => {
    let data = {
      user: {
        admin: checked,
      },
    };
    axios
      .put(`/admin/users/${user.id}/update`, data)
      .then((res) => {
        let updatedUser = res.data;
        setUsers(users => users.map((u) => {
          if(u.id === updatedUser.id) u = updatedUser;
          return u;
        }))

        setSuccessMessage("User role updated");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <ul className="list-group list-group-flush">
        {users.map((user) => {
          return (
            <li key={user.id} className="list-group-item flex-column align-items-start">
              <div className="w-100 d-flex justify-content-between align-items-start">
                <div className="flex-shrink-1">
                  <p className="my-0">{user.email || user.username}</p>
                  {user.data_collector && (
                    <p className="my-0 small fst-italic">Data collector</p>
                  )}
                </div>

                {/* Data collectors are external, so they cannot be made admins */}
                {!user.data_collector && (
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`admin-switch-${user.id}`}
                      checked={!!user.admin}
                      onChange={(e) => handleAdminChange(user, e.target.checked)}
                    />
                    <label
                      className="form-check-label small"
                      htmlFor={`admin-switch-${user.id}`}
                    >
                      Admin
                    </label>
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      <div id="success-container" className={successMessage !== "" && "active"}>
        <div id="success-content" className="small">
          {successMessage}
        </div>
      </div>
    </>
  );
};

export default UserList;
